import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@travelity/api';

function Callback() {
    const { error } = useAuth0();
    const navigate = useNavigate();
    const { data: user, isLoading } = useUser();

    if (error) {
        return <div>{error?.message}</div>;
    }

    if (!isLoading) {
        navigate(!user ? '/events' : '/events');
    }

    return null;
}

export default Callback;
